import { isNil } from 'es-toolkit';

type AdvisorData =
  | {
      client?: {
        assignedAdvisor?: {
          user?: {
            firstName?: string;
            lastName?: string;
          };
        };
      };
    }
  | null
  | undefined;

export function getAdvisorFullName(clientData: AdvisorData) {
  const firstName = clientData?.client?.assignedAdvisor?.user?.firstName;
  const lastName = clientData?.client?.assignedAdvisor?.user?.lastName;

  if (!isNil(firstName) && !isNil(lastName)) {
    return `${firstName} ${lastName}`;
  }

  return 'N/A';
}
